// extracted by mini-css-extract-plugin
export var swiperContainer = "NewsSlide-module--swiperContainer--kdMMP";
export var swiperSlide = "NewsSlide-module--swiperSlide--nr+MX";
export var categoryTxt = "NewsSlide-module--categoryTxt--oEKht";
export var newsImage = "NewsSlide-module--newsImage--1cvo0";
export var eyeCatchBgFdm = "NewsSlide-module--eyeCatchBgFdm--6LeVW";
export var eyeCatchBgLisa = "NewsSlide-module--eyeCatchBgLisa--22lRn";